import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState("TR");

  const languages = [
    { code: "tr", name: "Türkçe" },
    { code: "en", name: "English" },
    { code: "de", name: "Deutsch" },
  ];

  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectLanguage = (code) => {
    setSelectedLang(code);
    setIsOpen(false);
    i18n.changeLanguage(code);
  };

  useEffect(() => setSelectedLang(i18n.language), [i18n.language]);

  return (
    <div className="relative w-14">
      <button
        className="bg-red-600 text-white font-league-medium text-sm px-3 py-2 w-14 rounded-md flex items-center uppercase justify-center"
        onClick={toggleDropdown}
      >
        {selectedLang}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 ml-1 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="left-0 top-7 absolute my-3 min-w-full border-red-600 rounded-md shadow-lg focus:outline-none language-list-menu">
          <div className="py-1 border-2 rounded-lg bg-white border-red-600">
            {languages.map((lang) => (
              <a
                key={lang.code}
                className={`block px-4 py-2 text-sm cursor-pointer uppercase ${
                  selectedLang === lang.code
                    ? "text-red-200 font-league-bold"
                    : "text-red-600 font-league-bold hover:bg-gray-100"
                }`}
                onClick={() => selectLanguage(lang.code)}
              >
                <span>{lang.code}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
